import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Paper,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  TablePagination
} from '@mui/material';
import { useAuth } from '../../../../hooks/Auth';
import { useIntegration } from '../../../../hooks/Integration';
import { useModal } from '../../../../hooks/Modal';
import { ModalTitle, ModalText } from './styled';
import { ReverseCollectContext } from '../..';

export const ModalShowInvoiceSearchList = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isSearching, setIsSearching] = useState(true);
  const [invoiceSearchList, setInvoiceSearchList] = useState([]);

  const { token } = useAuth();
  const { searchInvoicesByKnowledgeId } = useIntegration();
  const { Modal } = useModal();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const {
    selectedKnowledgeIdToShowInvoices,
    selectedKnowledgeNumberToShowInvoices,
    openSearchKnowledgeModal
  } = useContext(ReverseCollectContext);

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }));

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14
    }
  }));

  const handleBack = () => {
    openSearchKnowledgeModal();
  };

  useEffect(async () => {
    try {
      const params = {
        pctrc: selectedKnowledgeIdToShowInvoices
      };

      const response = await searchInvoicesByKnowledgeId({ params, token });

      if (response.length > 0) {
        setInvoiceSearchList(response);
      }

      setIsSearching(false);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  }, []);

  return (
    <Modal preventClose>
      <Stack spacing={2}>
        <ModalTitle>Notas fiscais</ModalTitle>

        <ModalText>
          Número de Conhecimento: {selectedKnowledgeNumberToShowInvoices}
        </ModalText>

        <TableContainer component={Paper}>
          <Table stickyHeader size="small">
            <TableHead>
              <StyledTableRow>
                <StyledTableCell style={{ textAlign: 'center' }}>
                  Nota Fiscal
                </StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {invoiceSearchList.length === 0 ? (
                <StyledTableRow>
                  <StyledTableCell
                    style={{ textAlign: 'center', color: '#888' }}
                  >
                    {isSearching ? 'Pesquisando...' : 'Sem resultados'}
                  </StyledTableCell>
                </StyledTableRow>
              ) : (
                <>
                  {invoiceSearchList
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      return (
                        // eslint-disable-next-line react/no-array-index-key
                        <StyledTableRow key={`${row.invoice}-${index}`}>
                          <StyledTableCell style={{ textAlign: 'center' }}>
                            {row.invoice}
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                </>
              )}
            </TableBody>
            {invoiceSearchList.length > 5 && (
              <TableFooter>
                <TableRow>
                  <TablePagination
                    count={invoiceSearchList.length || 1}
                    page={page}
                    labelDisplayedRows={() => {
                      // eslint-disable-next-line prettier/prettier
                      return `Página ${page + 1} de ${Math.ceil(invoiceSearchList.length / rowsPerPage)}`;
                    }}
                    labelRowsPerPage="Itens por página:"
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    showFirstButton={
                      Math.ceil(invoiceSearchList.length / rowsPerPage) > 2
                    }
                    showLastButton={
                      Math.ceil(invoiceSearchList.length / rowsPerPage) > 2
                    }
                  />
                </TableRow>
              </TableFooter>
            )}
          </Table>
        </TableContainer>

        <Box
          style={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <Button
            type="button"
            variant="contained"
            color="secondary"
            onClick={handleBack}
          >
            Voltar
          </Button>
        </Box>
      </Stack>
    </Modal>
  );
};
